export function modelSettingsOnboardingProgress(
  keys: readonly { hasCredential: boolean }[],
  providerCount: number,
  catalog: readonly unknown[],
  allowedModelIds: readonly string[]
) {
  return {
    configuredKeys: keys.filter((key) => key.hasCredential).length,
    providerCount,
    deployedModels: catalog.length,
    assignedModels: allowedModelIds.length,
  };
}
